module.exports = __webpack_public_path__ + "img/shutu.7043abdb.png";